import { MapPin } from "@phosphor-icons/react";
import { TicketSource } from "shared/types/helpdesk";
import { PickerItemProps } from "../../types";
import { getSourceColor } from "../../utils/searchUtils";

export const SourceItem = ({ item, isSelected, onSelect }: PickerItemProps<TicketSource>) => {
  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors hover:bg-brick-secondary-fine ${
        isSelected ? "bg-moss-primary/10 border border-moss-primary/30" : ""
      }`}
    >
      <div className="flex items-center gap-2">
        <MapPin className="h-4 w-4 text-neutral-secondary-mid" />
        <div className={`px-2 py-1 rounded-md border text-xs font-medium ${getSourceColor(item)}`}>
          {item}
        </div>
      </div>
    </button>
  );
};